import React from 'react'
import Header from '../header/Header'
import hero_image from '../../assets/hero_image.png';
import hero_image_back from '../../assets/hero_image_back.png';
import Heart from '../../assets/heart.png';
import Calories from '../../assets/calories.png';
import NumberCounter from 'number-counter'
import './HeroSection.css'
import { Link } from 'react-scroll';
import { scroller } from 'react-scroll';



import {motion} from 'framer-motion'

const HeroSection = () => {

    const transition = { type: 'spring', duration: 3, repeat: Infinity, repeatType: 'reverse' };
    const mobile = window.innerWidth <= 768 ? true : false;

    return (
        <div className="hero" id="home">
            <div className="blur hero-blur"></div>
            <div className="left-h">
                <Header />
                <div className="the-best-ad">
                    <motion.div
                      initial={{ left: mobile ? "165px" : "238px" }}
                      animate={{ left: ['8px', mobile ? "165px" : "238px"] }} // Animate to both positions
                      transition={transition} // Transition for back and forth
                  ></motion.div>
                    <span>the best fitness club in the <span className='had'  > Kalepadal | Hadpsar </span> </span>
                </div>

                <div className="hero-text">
                    <div>
                        <span className="stroke-text">Shape </span>
                        <span>Your</span>
                    </div>
                    <div>
                        <span>Ideal body</span>
                    </div>
                    <div>
                        <span>
                            In here we will help you to shape and build your ideal body and live up your life to fullest
                        </span>
                    </div>
                </div>
                <div className="figures">
                    <div>
                        <span>
                            <NumberCounter 
                                end={10} 
                                start={0} 
                                delay="3"
                                preFix="+" 
                            />
                        </span>
                        <span>expert coachs</span>
                    </div>
                    <div><NumberCounter 
                                end={300} 
                                start={100} 
                                delay="4"
                                preFix="+" 
                            />
                        <span>
                            <NumberCounter 
                                end={300} 
                                start={100} 
                                delay="3"
                                preFix="+" 
                            />
                        </span>
                        <span>members</span>
                    </div>
                    <div>
                        <span>
                            <NumberCounter 
                                end={50} 
                                start={10} 
                                delay="3"
                                preFix="+" 
                            />
                        </span>
                        <span>fitness programs</span>
                    </div>
                </div>
                <div className="hero-buttons">
                    <buttons className="btn" onClick={() => scroller.scrollTo('reasons', { smooth: true, duration: 500 })}  > Get Started</buttons>
                    <buttons className="btn" onClick={() => scroller.scrollTo('testimonials', { smooth: true, duration: 500 })} >Learn More</buttons>
                </div>
            </div>

            <div className="right-h">
            <Link 
        to="Contact"  // The ID of your Contact section
        smooth={true}
        duration={500}
    >
        <button className="btn button "         onClick={() => scroller.scrollTo('Contact', { smooth: true, duration: 500 })}
 >Join Now</button>
    </Link>
            
                <motion.div 
                    initial={{ right: "-1rem" }}
                    whileInView={{ right: "4rem" }}
                    transition={transition}
                    className="heart-rate"
                >
                    <img src={Heart} alt="" />
                    <span>Heart Rate</span>
                    <span>116 bpm</span>
                </motion.div>
                <img src={hero_image} alt="" className="hero-image" />
                <motion.img 
                    initial={{ right: '11rem' }}
                    whileInView={{ right: "28rem" }}
                    transition={transition}
                    src={hero_image_back} 
                    alt=""
                    className="hero-image-back" 
                />
                <motion.div 
                    initial={{ right: "37rem" }}
                    whileInView={{ right: "28rem" }}
                    transition={transition}
                    className="calories"
                >
                    <img src={Calories} alt=""/>
                    <div>
                        <span>Calories Burned</span>
                        <span>220 kcal</span>
                    </div>
                </motion.div>  
            </div>
        </div>
  )
}

export default HeroSection